module.exports = __webpack_public_path__ + "static/media/lightbulb.031d7d19.gif";